import script from "./VBlockListSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./VBlockListSelect.vue?vue&type=script&lang=ts&setup=true"

import "./VBlockListSelect.vue?vue&type=style&index=0&id=14203b72&lang=sass"

const __exports__ = script;

export default __exports__